<form [formGroup]="itemForm()">
  <div class="app-item">
    <mat-form-field style="width: 8em">
      <mat-label i18n>Select Type</mat-label>
      <mat-select
        formControlName="type"
        (selectionChange)="typeSelected($event.value)"
      >
        @for (type of inputTypes | keyvalue ; track type) {
        <mat-option [value]="+type.key">{{ type.value }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (itemForm().controls.type.value !== null) {
    <mat-form-field>
      <input
        matInput
        formControlName="name"
        placeholder="Name"
        i18n-placeholder
      />
    </mat-form-field>
    <mat-checkbox formControlName="required" i18n> Required </mat-checkbox>
    <mat-form-field>
      <input
        matInput
        formControlName="renderTag"
        placeholder="pdf tag"
        i18n-placeholder
      />
    </mat-form-field>
    <mat-form-field style="width: 5em">
      <input
        type="number"
        matInput
        formControlName="sort"
        placeholder="Position"
        i18n-placeholder
      />
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        formControlName="description"
        placeholder="Description"
        i18n-placeholder
      />
    </mat-form-field>
    <button matButton="outlined" (click)="delete()" i18n>Delete Field</button>
    }
  </div>
  <div class="flex-row start-center">
    @for (opt of getValues(itemForm()); track opt; let i = $index) {
    <div>
      <span class="app-multi-label">
        @if (itemForm().controls.type.value === FieldTypes.RADIO) {
        <span><mat-icon>adjust</mat-icon></span>
        } @if (itemForm().controls.type.value === FieldTypes.MULTI) {
        <span><mat-icon>crop_square</mat-icon></span>
        } @if (itemForm().controls.type.value === FieldTypes.DROPDOWN) {
        <span><mat-icon>arrow_drop_down</mat-icon></span>
        }
        {{ opt.value }}
        <button matButton matSuffix aria-label="Clear" (click)="deleteValue(i)">
          <mat-icon class="cust-mat-icon">close</mat-icon>
        </button>
      </span>
    </div>
    }
  </div>
</form>
<form [formGroup]="addGroup">
  <div
    [hidden]="
      itemForm().controls.type.value !== FieldTypes.RADIO &&
      itemForm().controls.type.value !== FieldTypes.MULTI &&
      itemForm().controls.type.value !== FieldTypes.DROPDOWN
    "
  >
    <mat-form-field>
      <input
        matInput
        formControlName="addValue"
        placeholder="Add Value"
        i18n-placeholder
      />
    </mat-form-field>
    <button
      matIconButton
      (click)="addNewValue()"
      [disabled]="!addGroup.controls.addValue.value"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>
</form>
